import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        EMAIL_API: {
            API_URL: 'https://mailsender-hqncm2r2ja-uc.a.run.app',
            HOST_NAME: 'mail.ita.locamail.com.br',
            PORT: 587,
            USER: 'noreply@vaapty.com',
            PASS: 'noreply#1Vaapty', 
            TO: 'falecom@vaapty.com'
        }
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
})
